import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { AirlinesDataProvider } from "../../common/data/lookup-data-providers/AirlinesDataProvider";
import { DistributorsDataProvider } from "../../common/data/lookup-data-providers/DistributorsDataProvider";
import { HeaderBreadcrumb } from "../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../AdminRoutes";
import { EncodeCachingManager } from "./encode-caching/EncodeCachingManager";
import { WatermarkRuleProvider } from "./watermarks/context/WatermarkRuleProvider";
import { WatermarkRuleListing } from "./watermarks/listing/WatermarkRuleListing";

export const TEMDashboard: React.VFC = () => {
    return (
        <DistributorsDataProvider>
            <AirlinesDataProvider>
                <WatermarkRuleProvider>
                    <PageHeader>
                        <HeaderBreadcrumb routes={adminRoutes} />
                    </PageHeader>
                    <Grid>
                        <GridRow>
                            <GridColumn sm={4}>
                                <EncodeCachingManager />
                            </GridColumn>
                            <GridColumn sm={8}>
                                <WatermarkRuleListing />
                            </GridColumn>
                        </GridRow>
                    </Grid>
                </WatermarkRuleProvider>
            </AirlinesDataProvider>
        </DistributorsDataProvider>
    );
};
